import React, { useReducer, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import moment from "moment";
import _ from "lodash";
import tw from "tailwind-styled-components";
import * as HyperDX from "@hyperdx/browser";
import getSymbolFromCurrency from "currency-symbol-map";
import Skeleton from "@mui/material/Skeleton";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import IconButton from "@mui/material/IconButton";
import { FilterBox, ClubDetails } from "@containers";
import { WeatherView, PrimaryText } from "@components";
import { CheckLanguage, filterTeeTimeData } from "@utils";
import {
  apiCall,
  showLoder,
  updateDate,
  activePlayer,
  showCompleteLoder,
  removeReduxTeeTime,
  getSelectedPlayerData,
  getShowPrice,
} from "@store";
import TeeTimeView from "./widgets/teeTimeView";
import CartModal from "./widgets/addToCartModal";
import { CachedTimeView } from "./widgets/cachedTimeView";
import "../containerStyle.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";

function TeeTimeBooking() {
  const dispatch = useDispatch();
  const { t } = useTranslation("common");
  const addToCartData = useSelector((state) => state.bookings?.addToCartData);
  const updatedDate = useSelector((state) => state.teeTime.date);
  const activePlayers = useSelector((state) => state.courses.activePlayer);
  const isLoading = useSelector((state) => state.teeTime.showLoder);
  const { isNetworksError, reduxTeeTime, cachedTeeTime } = useSelector(
    (state) => state.teeTime
  );
  const showPrice = useSelector((state) => state.setting.showPrice);

  const apiTimer = useSelector((state) => state.setting.time);
  const playerTypeId = apiTimer?.data?.data;
  const teeTimeApiSlugdata = useSelector(
    (state) => state.teeTime.teeTimeApiSlug
  );
  const isCompleteLoading = useSelector(
    (state) => state.teeTime.showCompleteLoder
  );

  const theme = createTheme({
    palette: {
      secondary: {
        main: "#C7A76F",
      },
    },
  });

  const [state, setState] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      data: [],
      activeDate: moment(),
      loading: false,
      cartModal: false,
      lastCahcedDate: "",
      lastCachedHours: 0,
      lastCachedMinutes: 15,
      upComming_Date: [0, 1, 2, 3],
    }
  );

  const prices =
    addToCartData.length > 0
      ? addToCartData.map((a) => a?.actualPrice * a?.selectedPlayer)
      : "";
  const totalPrice =
    addToCartData.length > 0 ? prices.reduce((acc, curr) => acc + curr) : "";

  useEffect(() => {
    let localdata = JSON.parse(localStorage.getItem("LocalCartData"));
    if (localdata?.length && !addToCartData?.length) {
      dispatch(
        getSelectedPlayerData({ localdata: localdata, localSave: true })
      );
    }
    if (addToCartData?.length) {
      HyperDX.addAction("trackCartEvent", {
        cartItems: addToCartData,
        totalAmount: totalPrice,
      });
    }
  }, [dispatch, addToCartData]);

  useEffect(() => {
    setState({ activeDate: moment(teeTimeApiSlugdata?.apiData?.bookingDate) });
  }, [teeTimeApiSlugdata]);

  useEffect(() => {
    if (updatedDate) {
      setState({
        activeDate: updatedDate,
      });
    }
  }, [updatedDate]);

  useEffect(() => {
    const dateFilter = reduxTeeTime?.filter((res) => {
      return moment(res?.time).isSame(state.activeDate, "day");
    });
    const currentTimeFilter = _.filter(dateFilter, function (e) {
      if (moment(e?.time).format("D") === moment().format("D")) {
        return moment(e?.time).format("HHmm") > moment().format("HHmm");
      } else {
        return e;
      }
    });
    const playerFilter = currentTimeFilter?.filter((res) => {
      return res?.players >= activePlayers;
    });

    const filterTeesData = filterTeeTimeData(playerFilter);
    if (filterTeesData?.length) {
      setState({ data: filterTeesData });
    } else {
      setState({ data: [] });
    }
  }, [reduxTeeTime, state.activeDate, activePlayers]);

  useEffect(() => {
    let filterDate = cachedTeeTime?.filter((e) => {
      return e?.date === moment(state.activeDate).format("DDMMYYYY");
    });

    if (filterDate?.length) {
      const now = moment();
      const end = moment(filterDate[0]?.data?.lastCacheAt).local();
      const duration = moment.duration(now.diff(end));
      const hours = duration.hours();
      const minutes = duration.minutes();

      setState({
        lastCachedHours: hours,
        lastCachedMinutes: minutes,
        lastCahcedDate: filterDate[0]?.data?.lastCacheAt,
      });
    } else {
      setState({
        lastCachedHours: 0,
        lastCachedMinutes: 15,
        lastCahcedDate: moment(),
      });
    }
  }, [cachedTeeTime, state.activeDate, reduxTeeTime]);

  const closeModal = () => {
    setState({ cartModal: false });
  };

  const ShowMessage = (props) => {
    return (
      <div className="w-full h-full flex justify-center items-start mt-[40px] mb-[40px] py-[15px]">
        <PrimaryText
          className={"center text-2xl text-textColor animate-pulse text-start "}
        >
          {props.title}
        </PrimaryText>
      </div>
    );
  };

  const changeDate = (newDate) => {
    if (
      moment(state.activeDate).format("DD-MM-YYYY") ===
      moment(newDate).format("DD-MM-YYYY")
    ) {
    } else {
      dispatch(removeReduxTeeTime());
      dispatch(updateDate(newDate));
      dispatch(showLoder(true));
      dispatch(showCompleteLoder(true));
      dispatch(activePlayer(teeTimeApiSlugdata?.apiData?.players || 1));
      setState({ activeDate: moment(newDate), loading: true });
      setTimeout(() => {
        setState({ loading: false });
        dispatch(apiCall(true));
      }, 300);
    }
  };

  const DateView = (props) => {
    let dateLanguage = CheckLanguage() || "en";
    const dayName = moment(props?.title)
      .locale(dateLanguage)
      .format("ddd, D MMM");
    return (
      <DateBtn
        onClick={() => changeDate(props?.title)}
        disabled={isLoading || isCompleteLoading}
        className={`${
          moment(state.activeDate).format("DD-MM-YYYY") ===
          moment(props?.title).format("DD-MM-YYYY")
            ? "bg-primary hover:cursor-default"
            : `bg-black02 ${
                isLoading || isCompleteLoading
                  ? "hover:cursor-wait"
                  : "hover:opacity-70"
              }`
        }`}
      >
        <p className={`text-sm font-[Cambay] text-center text-white255`}>
          {dayName}
        </p>
      </DateBtn>
    );
  };

  const CartView = () => {
    return (
      <div
        className={`${
          addToCartData?.length < 1 ? "cursor-not-allowed" : "cursor-default"
        }`}
      >
        <div
          className={`w-fit h-[40px] flex flex-row items-center justify-start rounded-full gap-x-2 bg-black03 ${
            addToCartData?.length > 0 ? "hover:cursor-pointer" : ""
          } `}
          onClick={() =>
            setState({ cartModal: addToCartData?.length > 0 ? true : false })
          }
        >
          <div>
            <IconButton
              disabled={addToCartData?.length > 0 ? false : true}
              sx={{ bgcolor: "#ffffff36" }}
            >
              {addToCartData?.length > 0 ? (
                <ShoppingCartIcon fontSize="medium" sx={{ color: "white" }} />
              ) : (
                <ShoppingCartIcon fontSize="medium" sx={{ color: "#858585" }} />
              )}
            </IconButton>
          </div>
          {addToCartData?.length > 0 && (
            <div className="h-full sm:w-[80px] w-[105px] flex flex-col items-start justify-center overflow-hidden">
              <PrimaryText className="leading-4 text-white255 opacity-80 text-[13px]">
                {addToCartData?.length + " " + t("select")}
              </PrimaryText>
              <PrimaryText className="leading-4 text-white255 font-medium text-[17px]">
                {getSymbolFromCurrency(
                  addToCartData[0]?.price?.pricing[0]?.price?.currency
                ) +
                  " " +
                  totalPrice}
              </PrimaryText>
            </div>
          )}
        </div>
        <CartModal openModal={state.cartModal} closeModal={closeModal} />
      </div>
    );
  };

  const SkeletonLoader = () => {
    const TxtLoader = () => {
      return (
        <div className="w-[128px] h-[25px]">
          <Skeleton
            variant="text"
            sx={{ bgcolor: "#00000096" }}
            width={128}
            height={25}
          />
        </div>
      );
    };
    const BoxLoader = () => {
      return (
        <div className="w-[90px] h-[67px] rounded-lg">
          <Skeleton
            variant="rounded"
            sx={{ bgcolor: "#ffffff5c", borderRadius: "10px" }}
            animation="wave"
            width={90}
            height={67}
          />
        </div>
      );
    };

    const boxLoaderMap = Array(12).fill("");

    return (
      <LoaderView>
        <AnimationTeeTime>
          <div className="w-full h-full flex flex-col items-center gap-2">
            <TxtLoader />
            <AnimatedBox>
              {boxLoaderMap?.map((item, index) => (
                <BoxLoader key={index} />
              ))}
            </AnimatedBox>
          </div>

          <div className="w-full h-full xl3:flex hidden flex-col items-center gap-2">
            <TxtLoader />
            <AnimatedBox>
              {boxLoaderMap?.map((item, index) => (
                <BoxLoader key={index} />
              ))}
            </AnimatedBox>
          </div>
        </AnimationTeeTime>
      </LoaderView>
    );
  };

  const handleShowPrice = (event) => {
    dispatch(getShowPrice(event.target.checked));
  };
  const CourseName = () => {
    return (
      <div className="flex flex-row items-center justify-around xl2:my-[2px] my-2 w-20 h-auto">
        <div className="w-auto h-auto flex flex-row items-center justify-center gap-x-1">
       
          <ThemeProvider theme={theme}>
            <FormControlLabel
              control={
                <Switch
                  checked={showPrice}
                  onChange={handleShowPrice}
                  color="secondary"
                  size="large"
                  sx={{
                    "& .MuiSwitch-switchBase.Mui-checked": {
                      color: "white",
                    },
                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                      backgroundColor: "white",
                    },
                    "& .MuiSwitch-track": {
                      backgroundColor: "grey",
                    },
                  }}
                />
              }
              labelPlacement="start"
              sx={{ marginLeft: "0px", color: "white", fontWeight: "bold" }}
            />
          </ThemeProvider>
        </div>
      </div>
    );
  };

  return (
    <>
      <Root>
        <TEES>
          <Filters>
            <FilterBox />
            <WeatherView />
          </Filters>
          <div
            className={`${teeTimeBookingView}${
              !isLoading && !state.data?.length
                ? `xl2:w-full md3:w-[54%] w-full xl2:px-4 px-0`
                : `md:px-4 px-0 xl2:w-[54%] w-full`
            }`}
          >
            <Component>
              <div className={dateView}>
                {state.upComming_Date.map((e, i) => (
                  <DateView
                    key={`date${i}`}
                    title={moment(teeTimeApiSlugdata?.apiData?.bookingDate).add(
                      e,
                      "day"
                    )}
                  />
                ))}
              </div>
              <div className="h-auto w-auto flex md:flex-row flex-col md:items-start items-end gap-2">
                {!isLoading && !isCompleteLoading && (
                  <CachedTimeView
                    lastCachedHours={state.lastCachedHours}
                    lastCachedMinutes={state.lastCachedMinutes}
                    lastCahcedDate={state.lastCahcedDate || moment().local()}
                  />
                )}
                {CartView()}
              </div>
            </Component>

            {isNetworksError ? (
              <ShowMessage title={"Failed To Load TeeTime Data !"} />
            ) : isLoading || state.loading ? (
              <SkeletonLoader />
            ) : state.data?.length ? (
              <>
                {playerTypeId?.specialRatesBanner ? (
                  <div className="w-full h-auto bg-primary py-2 mt-2 mb-2 px-2 rounded-lg flex justify-center items-center gap-3">
                    <img
                      src={
                        "https://cdn-images1.zest.golf/kclub/dev/icon_64862a3310.png"
                      }
                      alt="golf-ireland-rates"
                      className="w-[26px] h-[26px] animate-pulse"
                    />
                    <p className="text-[19px] font-medium text-white text-start">
                      {playerTypeId?.specialRatesBanner}
                    </p>
                    <CourseName />
                  </div>
                ) : (
                  <></>
                )}

                <Container>
                  <TeeTimeView data={state.data} />
                </Container>
              </>
            ) : (
              <ShowMessage title={t("noTeeTimeMessage")} />
            )}
          </div>

          {addToCartData?.length > 0 ? (
            <div
              onClick={() =>
                setState({
                  cartModal: addToCartData?.length > 0 ? true : false,
                })
              }
              className="w-full h-auto bg-primary hover:bg-[#e2cda8] sm:hidden flex items-center justify-center gap-x-1 hover:cursor-pointer rounded-xl p-2 mb-6 mt-[-15px] text-[white] text-[17px] font-medium"
            >
              <ShoppingCartIcon fontSize="medium" sx={{ color: "white" }} />
              <p>{"Go to cart"}</p>

              <div className="h-[40px] w-[110px] ml-4 pl-5 flex flex-col items-start justify-center overflow-hidden rounded-full gap-x-1 border-[1px] border-[white] bg-[#5353533b]">
                <PrimaryText className="leading-4 text-white255 text-[13px]">
                  {addToCartData?.length + " " + t("select")}
                </PrimaryText>
                <PrimaryText className="leading-4 text-white255 font-medium text-[17px]">
                  {getSymbolFromCurrency(
                    addToCartData[0]?.price?.pricing[0]?.price?.currency
                  ) +
                    " " +
                    totalPrice}
                </PrimaryText>
              </div>
            </div>
          ) : (
            <></>
          )}
          <Clubs>
            <div className={club_View}>
              <ClubDetails />
            </div>
          </Clubs>
        </TEES>
      </Root>
    </>
  );
}

const Root = tw.div`
w-full 
h-auto
px-4
pt-4
flex
items-between
justify-center
lg2:flex-row
flex-col
`;
const TEES = tw.div`
h-auto
w-full
flex
xl2:flex-row
flex-col
xl2:items-start
items-center
justify-between
`;
const Filters = tw.div`
w-full
sm:max-w-[355px] max-w-full
h-auto 
md:flex
flex-col 
items-center
`;
const teeTimeBookingView = `
h-auto 
md2:my-0 
my:-[40px]
justify-center
items-center
xl2:pt-[6px]
pt-6
`;
const Clubs = tw.div`
w-full
sm:max-w-[355px] max-w-full
h-auto
md:flex
flex-row
items-between
justify-between
rounded-lg
`;

const club_View = `
w-full 
h-full 
flex 
xl2:justify-end justify-center 
rounded-lg
`;

const Container = tw.div`
w-auto
h-auto
mx-[2px]
px-[2px]
mt-[3px]
mb-[33px]
`;

const Component = tw.div`
w-full 
h-auto 
flex flex-row 
items-start justify-between 
gap-[4px] 
mx-[2px] 
px-[2px] 
mt[3px]
`;
const dateView = `
w-full 
h-auto 
flex 
flex-wrap 
itmes-center
gap-2
`;
const DateBtn = tw.button`
w-[90px] 
h-auto 
rounded-2xl 
flex 
items-center 
justify-center 
pt-[6px]
pb-[1px]
`;

const LoaderView = tw.div`
w-full 
lg2:h-[470px] h-fit 
flex 
flex-col 
justify-center 
items-center 
gap-2 
rounded-lg 
p-2 
overflow-hidden
mb-8
`;
const AnimationTeeTime = tw.div`
flex 
flex-row 
items-center 
justify-around 
w-full 
h-full 
rounded-lg 
gap-2
`;
const AnimatedBox = tw.div`
w-full 
h-full 
flex 
flex-wrap 
items-center 
justify-center 
gap-2 
border-[2px]
border-textColor 
rounded-2xl 
py-2
`;

export default TeeTimeBooking;
